<template lang="pug">
  div 🤷‍♂️
</template>

<script>
  import { mapState, mapActions } from 'vuex';


  export default {
    computed: {
      ...mapState([
        'interestId', 
        'interestType',
      ]),
    },

    methods: {
      ...mapActions(['submit']),

      handleSubmit ({ email, name, phone, gdprConfirmed, newsletter, recaptchaResponse }) {
        const { interestId, interestType } = this;

        this.submit({
          email,
          name,
          phone,
          gdprConfirmed,
          newsletter,
          interestId,
          interestType,
          recaptchaResponse,
        });
      },
    },
  };
</script>
